import { TextureLoader, LoadingManager } from 'three';
import { AudioLoader } from 'three';
import { GLTFLoader } from 'three-utils';
import { isPhoneLayout } from './phone-layout.js';

export const loadingManager = new LoadingManager();

function setBundleHashText(text) {
	for (const el of document.querySelectorAll('splash-build-hash, client-build-hash')) {
		el.textContent = text;
	}
}

function ensureBundleHashBadge() {
	let badge = document.querySelector('client-build-hash');
	if (!badge) {
		badge = document.createElement('client-build-hash');
		document.body.appendChild(badge);
	}
	// phone layout (ticket #25, user 2026-10-24: "the debug notes should go a little inward so they are inside the spine"): the strip starts
	// right of the left spine/bar (frame 8 px + spine 12 px), same bottom position; desktop keeps the CSS default
	if (isPhoneLayout()) { badge.style.left = '30px'; badge.style.maxWidth = 'calc(100% - 38px)'; badge.style.overflow = 'hidden'; badge.style.whiteSpace = 'nowrap'; }
	return badge;
}

// The server computes the bundle hash once per bundling and puts it into the SSR page (server.js, splash-build-hash
// data-hash); the client never downloads the bundle a second time just to hash it.
export function showClientBundleHash() {
	ensureBundleHashBadge();
	const hash = document.querySelector('splash-build-hash')?.dataset.hash;
	setBundleHashText(hash ? `bundle ${hash.slice(0, 12)}` : 'bundle hash unavailable');
}

if (document.body) {
	showClientBundleHash();
} else {
	window.addEventListener('DOMContentLoaded', showClientBundleHash, { once: true });
}

// DEV telemetry ticker: append live renderer/build stats to the bundle badge,
// once per second. Exists because phones have no reachable console (release
// Firefox/Android does not mirror console to logcat) — remote screencaps of
// this line are the only field telemetry. window.__maBuilds is bumped by
// client/planet.js on every planet build.
setInterval(() => {
	const g = window.game;
	if (!g?.renderer) return;
	const m = g.renderer.info.memory;
	const tiers = Object.values(g.entities?.ids || {})
		.filter(e => e && e.$p && e.tier)
		.map(e => e.tier[0]).sort().join('');
	const el = document.querySelector('client-build-hash');
	if (!el) return;
	const base = (el.textContent || '').split(' | ')[0];
	// r: = active planet renderer (client/planet.js PLANET_RENDERER) — a phone
	// screenshot of this line proves legacy vs next without a console.
	el.textContent = `${base} | r:${window.__maRenderer || '?'} b:${window.__maBuilds || 0} tex:${m.textures} geo:${m.geometries} t:${tiers}`;
}, 1000);

export function splashDone() {
	if (window._splashObserver) window._splashObserver.disconnect();
	const bar = document.querySelector('splash-progress-bar');
	if (bar) bar.style.width = '100%';
	if (!controller.$classes.includes('loaded')) {
		controller.$classes.push('loaded');
	}
	$('body').setAttribute('class', controller.$classes.join(' '));
	// Remove the initial splash entirely after its slide-out (top 0.2s). Otherwise the
	// next SPA navigation overwrites body's class with the new controller's $classes
	// (dropping 'loaded'), so `body.loaded splash-screen-container { top: 100vh }` stops
	// matching and the splash slides back over the page. It's the init loader — once
	// dismissed it must never return (SPA navigation uses loader-container instead).
	setTimeout(() => document.querySelector('splash-screen-container')?.remove(), 400);
}

export const textureLoader = new TextureLoader(loadingManager);
export const audioLoader = new AudioLoader(loadingManager);
export const gltfLoader = new GLTFLoader(loadingManager);
